import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home";
import Login from "./views/Login";
import store from "./store";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/home",
            name: "home",
            component: Home,
            meta: { requiresAuth: true }
        },{
            path: "/",
            name: "login",
            component: Login
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        const forceChangePwd = localStorage.getItem('forceChangePwd') === 'true' || (store && store.state.user.forceChangePwd);
        const hasToken = !!localStorage.getItem('token') && !!localStorage.getItem('loginToken');
        const hasUserId = !!localStorage.getItem('userId');
        
        // 优先判断 localStorage 中的登录凭证，避免登录成功后的时序问题
        if (hasToken && hasUserId && !forceChangePwd) {
            next();
        } else if (store && store.state.user.logined && store.state.user.userId && !forceChangePwd) {
            // 兜底：store 状态已同步的情况
            next();
        } else {
            if (to.path !== '/') {
                next('/');
            } else {
                next();
            }
        }
    } else {
        next();
    }
});

export default router;
